import * as types from '@/store/types';

export default {
  [types.CONTROL_STATUS](state, { control }){
    state.control = control.data;
  }
};
